import parser from './src';

export default parser;
